import { useMemo, useState } from "react";

/**
 * Multi-select for catalog applications.
 * Empty value = all applications (no API filter param).
 */
export default function ApplicationMultiSelectDropdown({
  options,
  value,
  onChange,
  width = 220,
}) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");

  const allIds = useMemo(() => options.map((o) => o.id), [options]);
  const isAll =
    !value ||
    value.length === 0 ||
    (allIds.length > 0 &&
      value.length === allIds.length &&
      allIds.every((id) => value.includes(id)));

  function toggle(id) {
    const current = isAll ? [...allIds] : [...(value || [])];
    let next = current.includes(id)
      ? current.filter((v) => v !== id)
      : [...current, id];
    if (next.length === 0 || next.length === allIds.length) {
      onChange([]);
      return;
    }
    onChange(next);
  }

  function selectAll() {
    onChange([]);
  }

  const filtered = options.filter((o) =>
    (o.label || o.id).toLowerCase().includes(search.toLowerCase())
  );

  const label = isAll
    ? "All Applications"
    : value.length === 1
      ? options.find((o) => o.id === value[0])?.label || value[0]
      : `${value.length} applications`;

  return (
    <div style={{ position: "relative", width }}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        style={{
          width: "100%",
          height: 36,
          border: "1px solid #d1d5db",
          borderRadius: 8,
          padding: "0 10px",
          textAlign: "left",
          background: "#fff",
          cursor: "pointer",
        }}
      >
        {label} ▾
      </button>

      {open && (
        <div
          style={{
            position: "absolute",
            top: "110%",
            left: 0,
            width: "100%",
            border: "1px solid #d1d5db",
            borderRadius: 8,
            background: "#fff",
            zIndex: 20,
            boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
          }}
        >
          <div style={{ padding: 8, borderBottom: "1px solid #e5e7eb" }}>
            <button
              type="button"
              onClick={selectAll}
              style={{
                width: "100%",
                height: 28,
                borderRadius: 6,
                border: "1px solid #d1d5db",
                background: isAll ? "#eff6ff" : "#fff",
                cursor: "pointer",
                fontSize: 12,
              }}
            >
              All
            </button>
          </div>

          <div style={{ padding: 8 }}>
            <input
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search…"
              style={{
                width: "100%",
                height: 30,
                border: "1px solid #d1d5db",
                borderRadius: 6,
                padding: "0 8px",
                boxSizing: "border-box",
              }}
            />
          </div>

          <div style={{ maxHeight: 220, overflowY: "auto", padding: "0 8px 8px" }}>
            {filtered.map((o) => {
              const checked = isAll || (value || []).includes(o.id);
              return (
                <label
                  key={o.id}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    padding: "6px 4px",
                    cursor: "pointer",
                    fontSize: 13,
                  }}
                >
                  <input
                    type="checkbox"
                    checked={checked}
                    onChange={() => toggle(o.id)}
                  />
                  <span>{o.label || o.id}</span>
                </label>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
